import Vue from 'vue'

Vue.filter('user', function (user) {
  return `${user.userName} (${user.userId})`
})
